import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { openPayByOfficialChat } from 'utils/JSBridge'
import { Toast } from 'antd-mobile'

// ------------------------------------
// Constants
// ------------------------------------
export const TRANSACTION_HISTORY = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  QUERY_FILTER_CONDITION_REQUEST: null,
  QUERY_FILTER_CONDITION_SUCCESS: null,
}, 'TRANSACTION_HISTORY')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          filterCode: 'PPC_MC',
          ...data
        },
        endpoint: 'cgs/personal/bill/list',
        requestAction: TRANSACTION_HISTORY.INIT_REQUEST,
        successAction: TRANSACTION_HISTORY.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function queryFeeList(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          viewCode: 'PPC_MC_P',
          iterationDirection: 'F',
          periodType: 'MONTH',
          begin: data.month,
          end: data.month,
          ...data
        },
        endpoint: 'cgs/feebill/query/v1/query-list',
        requestAction: TRANSACTION_HISTORY.INIT_REQUEST,
        successAction: TRANSACTION_HISTORY.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getFeeBillFile(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          viewCode: 'PPC_MC_P',
          fileType: 'PDF',
          periodType: 'MONTH',
          ...data
        },
        endpoint: 'cgs/feebill/file/v1/gen-file',
        requestAction: TRANSACTION_HISTORY.INIT_REQUEST,
        successAction: TRANSACTION_HISTORY.INIT_SUCCESS,
        success: function(result) {
          openPayByOfficialChat()
          Toast.hide()
        },
      })
    )
  }
}

export function queryFilterCondition() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/personal/bill/queryFilterCondition',
        requestAction: TRANSACTION_HISTORY.QUERY_FILTER_CONDITION_REQUEST,
        successAction: TRANSACTION_HISTORY.QUERY_FILTER_CONDITION_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [TRANSACTION_HISTORY.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [TRANSACTION_HISTORY.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, { dataList: [] }, action.payload),
  [TRANSACTION_HISTORY.QUERY_FILTER_CONDITION_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [TRANSACTION_HISTORY.QUERY_FILTER_CONDITION_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'transactionHistory',
    reducerMap: {
      transactionHistoryState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
